import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

// ------------------------------------
// Contants
// ------------------------------------
export const API_PREFIX = '/role'

export const RECEIVE_ROLE_LIST = `PERMISSION_RECEIVE_ROLE_LIST`

export const RECEIVE_ROLE_DETAIL = `PERMISSION_RECEIVE_ROLE_DETAIL`

export const RECEIVE_PERMISSION_LIST = `PERMISSION_RECEIVE_PERMISSION_LIST`

export const ADD_ROLE = `PERMISSION_ADD_ROLE`

export const DELETE_ROLE = `PERMISSION_DELETE_ROLE`

export const ADD_PERMISSION = `PERMISSION_ADD_PERMISSION`

export const DELETE_PERMISSION = `PERMISSION_DELETE_PERMISSION`

export const DEFAULT_SIZE = 10

export const CHANGE_PAGE = `USER_CHANGE_PAGE`

export const SHOW_MODAL = `PERMISSION_SHOW_MODAL`

export const HIDE_MODAL = `PERMISSION_HIDE_MODAL`

export const CHANGE_CURROLE = `PERMISSION_CHANGE_CURROLE`

export const CHANGE_ROLE_PERMISSION = `PERMISSION_CHANGE_ROLE_PERMISSION`

export const CHANGE_CURRENT_NAME = `PERMISSION_CHANGE_CURRENT_NAME`


// function getData(params,dispatch) {
//     return http.get(`/account/list?${qs.stringify(params)}`)
//         .then(data => {
//             dispatch({
//                 type: RECEIVE_LIST,
//                 data: data.data
//             })
//         })
// }
export function getRoleList() {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/list?size=1000`)
            .then(data => {
                dispatch({
                    type: RECEIVE_ROLE_LIST,
                    data: data.data.list
                })
            })
    }
}

export function getDetailRole(id) {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/detail/${id}`)
            .then(data => {
                dispatch({
                    type: CHANGE_CURROLE,
                    data: data.data
                })
            })
    }
}

export function addRole(name) {
    return (dispatch,getState) => {
        return http.post(`${API_PREFIX}/add`,name)
            .then(data => {
                dispatch({
                    type: ADD_ROLE,
                    data: data.data
                })
            }).then(() => {
                getRoleList()(dispatch,getState)
            })
    }
}

export function deleteRole() {
    return (dispatch,getState) => {
        const {permission:{showModal: {id}}} = getState()
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(data => {
                dispatch({
                    type: DELETE_ROLE
                })
            }).then(() => {
                dispatch({type: HIDE_MODAL})
                getRoleList()(dispatch,getState)
            })
    }
}

export function getPermissionList() {
    return (dispatch,getState) => {
        return http.get(`/permission/list`)
            .then(data => {
                dispatch({
                    type: RECEIVE_PERMISSION_LIST,
                    data: data.data.total
                })
            })
    }
}

export function addPermission(name) {
    return (dispatch,getState) => {
        return http.post(`/permission/add`,name)
            .then(data => {
                dispatch({
                    type: ADD_PERMISSION,
                    data: data.data
                })
            }).then(() => {
                getPermissionList()(dispatch,getState)
            })
    }
}

export function deletePermission() {
    return (dispatch,getState) => {
        const {permission:{showModal: {id}}} = getState()
        return http.get(`/permission/delete/${id}`)
            .then(data => {
                dispatch({
                    type: DELETE_PERMISSION
                })
            }).then(() => {
                dispatch({type: HIDE_MODAL})
                getPermissionList()(dispatch,getState)
                dispatch({ type: CHANGE_CURRENT_NAME,value: ''})
            })
    }
}

export function changeRolePermission(id,permissionIds) {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/set-role-permission/${id}?permissionId=${permissionIds}`)
            .then(() => {
                getDetailRole(id)(dispatch,getState)
            })
    }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
    list: [],
    total: 0,
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    roles: [],
    roleDetail:[],
    permissions: [],
    showModal: {
        isDelRole: false,
        isDelPermission: false,
        id: null
    },
    currRole: {
        rolePermissions: []
    },
    currentName: ''
}
export default createReducer(initialState, {
    [RECEIVE_ROLE_LIST]:(state,{data}) => {
        return {...state,roles: data, currRole: data[0]}
    },
    [RECEIVE_ROLE_DETAIL]: (state,{data}) => {
        return {...state,roleDetail: data}        
    },
    [RECEIVE_PERMISSION_LIST]:(state,{data}) =>{
        return {...state,permissions: data}
    },
    [ADD_ROLE]: (state,{value}) => {
        return {...state,value}
    },
    [DELETE_ROLE]: (state,{id}) => {
        return {...state,id}
    },
    [SHOW_MODAL]: (state,{key,id}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_CURROLE]: (state,{data}) => {
        return {...state,currRole: data}
    },
    [CHANGE_ROLE_PERMISSION]: (state,{currRoleId,checkId}) => {
        return {...state,currRoleId,checkId}
    },
    [CHANGE_CURRENT_NAME]: (state,{value}) => {
        return {...state,currentName: value}
    }
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/permission/reducers/list.js